import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./ReduxSlices/authSlice";
import managerReducer from "./ReduxSlices/managerSlice";
import candidateReducer from "./ReduxSlices/candidateSlice";
import assessmentReducer from "./ReduxSlices/assessmentSlice";
import subscriptionReducer from "./ReduxSlices/subscriptionPlanSlice";
import seoRegistrationReducer from "./ReduxSlices/seoDataSlice";
import excutiveReducer from "./ReduxSlices/addExcutiveSlice";
import notifierEmailReducer from "./ReduxSlices/notifierEmail";
import customTemplateReducer from "./ReduxSlices/customeTemplateSlice";
import openPositionsReducer from "./ReduxSlices/openPositionsSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    manager: managerReducer,
    candidate: candidateReducer,
    assessment: assessmentReducer,
    subscriptionPlans: subscriptionReducer,
    seoRegistration: seoRegistrationReducer,
    excutive: excutiveReducer,
    notifier: notifierEmailReducer,
    templateSlice: customTemplateReducer,
    openPositions: openPositionsReducer,
  },
});

export default store;
